// services/questionMappingService.js
import { create, getAll, getById, remove } from './baseService';

const endpoint = 'question-mappings';

const questionMappingService = {

  getAllMappings: (params) => getAll(endpoint, params),


  getMappingById: (id) => getById(endpoint, id),

  getMappingByExerciseId: (id) => getById(`${endpoint}/exercise`, id),
  getMappingByTestId: (id) => getById(`${endpoint}/test`, id),


  createMapping: (data) => create(endpoint, data),


  deleteMapping: (id) => remove(endpoint, id),
};

export default questionMappingService;
